import ClientService from "src/services/ClientService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	company_id: "",
	name: "",
	cto: "",
	num: "",
	postal: "",
	address: "",
	city: "",
	contact_man: "",
	tel: "",
	email: "",
	price: 0,
	outside:0,
	next_price: null,
	from_3_price: null,
	from_4_price: null,
	from_5_price: null,
	standard_price:null

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.client,
@property  {array}  modules.clients
 **/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator("client", ClientService, module, types ,params);
